import type { TooltipProps } from '@mui/material/Tooltip';

/** Compact Map-card segments stay under the chart; Design keeps left placement. */
export const getProgramDonutSegmentTooltipPlacement = (
  compact: boolean,
): NonNullable<TooltipProps['placement']> => (compact ? 'bottom' : 'left');

/**
 * Shared Popper config so segment tooltips anchor to the whole chart and do not
 * flip above/below when hovering different arcs.
 * Compact Map cards also pull the tooltip closer to the chart edge.
 */
export const getProgramDonutTooltipSlotProps = (
  chartElement: HTMLElement | null,
  options?: { disableFlip?: boolean; outerRadiusRatio?: number },
): NonNullable<TooltipProps['slotProps']> => {
  const outerRadiusRatio = options?.outerRadiusRatio;
  return {
    popper: {
      anchorEl: chartElement,
      ...(options?.disableFlip && {
        modifiers: [
          { name: 'flip', enabled: false },
          // Default MUI tooltip margin sits far below the compact Map card chart.
          {
            name: 'offset',
            options: {
              offset:
                outerRadiusRatio === undefined
                  ? [0, 4]
                  : ({
                      reference,
                    }: {
                      reference: { width: number; height: number };
                    }) => [
                      0,
                      8 +
                        reference.width * outerRadiusRatio -
                        reference.height / 2,
                    ],
            },
          },
        ],
      }),
    },
    tooltip: {
      style: {
        textAlign: 'center' as const,
        ...(options?.outerRadiusRatio !== undefined && { margin: 0 }),
      },
    },
  };
};
